// src/pages/BangTin.js
import React from "react";
import { Link } from "react-router-dom";
import ViecNhoBan from "../components/ViecNhoBan";
import ReminderList from "../components/ReminderList";
import BietGiChua from "../components/BietGiChua";

// ============================================================
// BẢNG TIN — "Nhà mình đang có chuyện gì?"
// ------------------------------------------------------------
// ⚠️ ĐÂY LÀ BẢNG TIN. KHÔNG PHẢI BẢNG ĐIỀU KHIỂN.
//
// Chủ nhà 08/09/2026: *"ý tôi muốn trang Bảng tin phải thật sự là bảng tin,
// cần thiết có nút điều hướng xem thêm hoặc chuyển trang. Trình bày như
// vậy quá nghiệp dư."*
//
// Gốc của cái "nghiệp dư" đó: trang này từng là một lưới BỐN ô sửa/xóa
// được — Lịch chung · Việc nhà chung · Hóa đơn chung · Công thức chung — soi
// gương đúng bốn ô riêng bên "Trang của tôi". Chính chú thích cũ của file
// này đã viết "bảng tin không phải chỗ phân việc", rồi bên dưới lại đặt bốn
// ô thao tác. Bốn ô đó đã gỡ hết ở Đợt 4 → N2; từ đó trang này KHÔNG còn
// một nút sửa/xóa nào. Đừng thêm lại.
//
// ============================================================
// THỨ TỰ CÁC KHỐI — đã đổi 09/09/2026, và đây là lý do
// ------------------------------------------------------------
// Chủ nhà, sau khi dùng thật:
//
//   *"Theo đời thường: 'Biết gì chưa' sẽ là tin mới hơn 'nhắc nhở hôm nay',
//    cho nó lên trên cho 'nóng hơn'."*
//
// Đúng, và có một lý do máy móc đứng sau cảm giác đó: khối "Nhắc nhở hôm
// nay" KHÔNG PHẢI hôm nay. Máy chủ lọc `reminder <= hôm nay AND reminded =
// false` — lời nhắc không bao giờ tự hết hạn, nó nằm đó tới khi có người
// bấm "Tắt nhắc". Ảnh chụp ngày 09/09 của chủ nhà cho thấy khối đó đang
// hiện lời nhắc đề ngày 25/8 và 30/8. Tức là thứ chiếm chỗ đẹp nhất màn
// hình, tô màu đỏ, lại là một ĐỐNG TỒN ĐỌNG đội tên "hôm nay".
//
// ✅ ĐÃ SỬA GỐC Ở N4 (14/09/2026): lời nhắc đọc từ hàng đợi `nhac_nho`, sự
// kiện qua ngày thì tự mất, việc nhà chuyển sang khối "Người nhà đang nhờ
// bạn" (gắn 🔔). Thứ tự các khối vẫn giữ như anh chọn 09/09.
//
// ⚠️ `ViecNhoBan` VẪN Ở TRÊN CÙNG, cố ý. "Ai đang nhờ mình cái gì" là
// quyết định số 1 của tài liệu chân dung. Chủ nhà chỉ so "Biết gì chưa"
// với "Nhắc nhở hôm nay", không đòi nó vượt lên trên việc của chính mình —
// và tin của cả nhà đứng trên việc người ta nhờ riêng mình thì sai thứ tự
// quan tâm. Đừng "sửa lại cho gọn" bằng cách đẩy nó lên đầu.
//
// ============================================================
// KHỐI CHI TIÊU ĐÃ BỎ KHỎI TRANG NÀY — 09/09/2026
// ------------------------------------------------------------
// Chủ nhà, sau khi dùng thật:
//
//   *"Bảng chi tiêu không nên thường trực hiện diện, chiếm chỗ (có ai đòi
//    nợ đâu?), cùng lắm vào một ngày nào đó trong tháng Ba sẽ nhắc nhở:
//    'vào xem chi tiêu tháng này của nhà mình'."*
//
// ⚠️ ĐIỀU NÀY SỬA CHÂN DUNG 4.3, KHÔNG PHẢI LÀM NGƯỢC NÓ. Mục 4.3 vẽ khối
// số nằm thường trực trên Bảng tin, với lý do: ở Zalo thì ảnh hóa đơn
// TRÔI MẤT sau vài chục tin nhắn. Mục đích đó vẫn còn nguyên — số liệu
// nằm yên trên trang Báo chi tiêu, không trôi đi đâu cả. Thứ bị bỏ chỉ là
// cách trình bày: chiếm chỗ suốt tháng.
//
// Chủ nhà đã chọn hình dạng thay thế (09/09/2026): **Ba tự bấm "báo cả
// nhà"** — không phải app tự nguội sau vài ngày. ✅ Có từ N4 (14/09/2026):
// nút "📣 Báo cả nhà vào xem" nằm ở trang Báo chi tiêu; lời nhắc hiện ở
// dòng đầu khung "Nhắc nhở hôm nay" của từng người, tới khi người đó vào xem.
// Đường vào Báo chi tiêu vẫn còn ở hàng nút bên dưới.
// ============================================================
function BangTin({ user }) {
  return (
    <>
      {/* Trên cùng: ai đang nhờ mình cái gì. Chỉ là TIN BÁO, không có nút
          thao tác nào (quyết định số 1 trong tài liệu chân dung). */}
      <ViecNhoBan user={user} />

      {/* Tin mới của cả nhà — tên do chính chủ nhà đặt (chân dung 4.1).
          CHỈ ĐỌC. Đứng trên khối nhắc nhở kể từ 09/09/2026. */}
      <BietGiChua />

      <ReminderList />

      {/* Hàng nút chuyển trang — thay cho mấy ô CRUD bị bỏ.
          ⚠️ CHỈ ĐẶT ĐƯỢC ĐƯỜNG DẪN CÓ THẬT — nút bấm vào không đi đâu
          còn tệ hơn không có nút. Cả bốn đường dưới đây đều có route trong
          App.js. "Sân chơi" chưa có trang (N7) — đừng thêm vào đây cho đủ hàng.

          Chỉ đặt những mục KHÔNG có trên thanh tab. Đi chợ đã có tab riêng nên
          không lặp lại ở đây — một đích đến hai chỗ bấm trên cùng một màn
          hình là thêm việc cho người đọc chọn.

          💡 Mẹo vặt (N6): anh chốt MV1 15/09 — đặt Ở ĐÂY, không lên thanh tab.
          Mẹo là thứ tra khi cần, giống Danh bạ; thanh tab trên điện thoại đã
          xuống hai dòng. */}
      <div className="hang-dieu-huong">
        <Link to="/lich" className="nut-dieu-huong">📅 Lịch</Link>
        <Link to="/chi-tieu" className="nut-dieu-huong">💰 Báo chi tiêu</Link>
        <Link to="/danh-ba" className="nut-dieu-huong">📞 Danh bạ nhà mình</Link>
        <Link to="/meo-vat" className="nut-dieu-huong">💡 Mẹo vặt</Link>
      </div>
    </>
  );
}

export default BangTin;
